import React from 'react'
import { Link } from 'react-router-dom'
import {
  MainBody,
  Projetos,
  Container,
  Border,
  Ferramentas
} from './Main-Styled'
import figma from '../../images/Ferramentas/figma.png'
import notion from '../../images/Ferramentas/notion.png'
import photoshop from '../../images/Ferramentas/photoshop.png'
import illustrator from '../../images/Ferramentas/illustrator.png'
import adSports from '../../images/projeto-adSports.png'
import frotaAdvisor from '../../images/projeto-frotaAdvisor.png'
import projetoBoraJuntas from '../../images/projeto-bora-juntas.png'
import projetoNendostore from '../../images/projeto-nendostore.png'
import projetoSerenity from '../../images/projeto-serenity.png'
import HeaderPage from '../../Components/Header/Header'
import FooterPage from '../../Components/Footer/Footer'
function Main() {
  return (
    <>
      <HeaderPage />

      <MainBody>
        <div id="sobre">
          <h2>UX/UI Designer</h2>
          <h1>Olá, sou Lygia Magalhães</h1>

          <p>
            Transformo necessidades dos usuários em experiências digitais
            intuitivas, acessíveis e visualmente consistentes. Sou graduada em
            Design, pós-graduada em User Experience e atuo com pesquisa,
            prototipação e design de interfaces para criar produtos que unem
            usabilidade e estratégia.
          </p>
          <p>
            Busco compreender os problemas antes de propor soluções, utilizando
            processos centrados no usuário para desenvolver produtos que gerem
            valor tanto para as pessoas quanto para o negócio.
          </p>
          <p>
            Estou sempre aberta a conversar sobre UX/UI Design, produtos
            digitais e novas oportunidades de colaboração.
          </p>

          <p>Vamos conversar?</p>
        </div>

        <div className="LinksPrincipais">
          <ul>
            <li>
              <a
                target="blank"
                href="https://www.linkedin.com/in/lygia-magalhaes/"
              >
                <span>
                  <div className="icone"></div>
                  <p>LinkedIn</p>
                </span>
              </a>
            </li>

            <li>
              <a target="blank" href="https://www.behance.net/lygia-magalhaes">
                <span>
                  <div className="icone2"></div>
                  <p>Behance</p>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </MainBody>

      <Ferramentas className="ferramentas">
        <Container>
          <h3 className="sectName">Ferramentas</h3>

          <ul>
            <li>
              <div className="tool">
                <img src={figma} alt="Figma" />
                <p>Figma</p>
              </div>
            </li>

            <li>
              <div className="tool">
                <img src={notion} alt="Notion" />
                <p>Notion</p>
              </div>
            </li>

            <li>
              <div className="tool">
                <img src={photoshop} alt="Adobe Photoshop" />
                <p>Adobe Photoshop</p>
              </div>
            </li>

            <li>
              <div className="tool">
                <img src={illustrator} alt="Adobe Illustrator" />
                <p>Adobe Illustrator</p>
              </div>
            </li>
          </ul>
        </Container>
      </Ferramentas>

      <Projetos>
        <Container id="projetos">
          <h3 className="sectName">Projetos</h3>

          <ul className="cards">
            <li>
              <Link to="/frota-advisor">
                <img src={frotaAdvisor} alt="" />
                <h3 className="projName">Frota Advisor</h3>
                <h5>Product Design</h5>
                <p>
                  Aplicativo que conecta motoristas, transportadoras e
                  prestadores a fim de encontrarem ou oferecerem serviços
                </p>
              </Link>
            </li>

            <li>
              <Link to="/adsports">
                <img src={adSports} alt="" />
                <h3 className="projName">AdSports</h3>
                <h5>Product Design</h5>
                <p>
                  Plataforma que conecta atletas, entidades esportivas e marcas
                  interessadas em oportunidades de patrocínio
                </p>
              </Link>
            </li>

            <li>
              <Link to="/bora-juntas">
                <img src={projetoBoraJuntas} alt="" />
                <h3 className="projName">Bora Juntas</h3>
                <h5>UX/UI Design</h5>
                <p>
                  Aplicativo de caminhada e rotas voltadas para segurança
                  feminina.
                </p>
              </Link>
            </li>

            <li>
              <Link to="/nendostore">
                <img src={projetoNendostore} alt="" />
                <h3 className="projName">NendoStore</h3>
                <h5>UX/UI Design</h5>
                <p>
                  Prototipagem avançada de interface para um e-commerce de
                  nendoroid.
                </p>
              </Link>
            </li>

            <li>
              <Link to="/serenity">
                <img src={projetoSerenity} alt="" />
                <h3 className="projName">Serenity</h3>
                <h5>UX Writing</h5>
                <p>
                  Criação de copy e aplicação do escopo em chatbot na plataforma
                  TakeBlip.
                </p>
              </Link>
            </li>
          </ul>
        </Container>
      </Projetos>

      <Border />
      <FooterPage />
    </>
  )
}

export default Main
